import { AsyncPipe } from '@angular/common'
import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { map } from 'rxjs'
import { Meeting, MeetingsService } from '../../meetings.service'
import { ProgressLoaderComponent } from '../../common/progress-loader/progress-loader.component'
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component'
import { ToastService } from '../../toast.service'

@Component({
  selector: 'app-legacy-minutes-notice',
  standalone: true,
  imports: [AsyncPipe, MatButtonModule, MatIcon, ProgressLoaderComponent, TranslatePipe],
  templateUrl: './legacy-minutes-notice.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './legacy-minutes-notice.component.scss',
})
export class LegacyMinutesNoticeComponent {
  @Input({ required: true })
  meeting!: Meeting

  @Input({ required: true })
  canUserEdit!: boolean

  private meetingsService = inject(MeetingsService)
  private dialog = inject(MatDialog)
  private toastService = inject(ToastService)
  private translateService = inject(TranslateService)

  private createEditorDocumentMutation = this.meetingsService.createEditorDocumentMutation()
  isRegenerationPending$ = this.createEditorDocumentMutation.result$.pipe(map((result) => result.isPending))

  regenerate() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.translateService.instant('EDITOR.LEGACY_MINUTES.CONFIRM_TITLE'),
        description: this.translateService.instant('EDITOR.LEGACY_MINUTES.CONFIRM_DESCRIPTION'),
      },
    })
    dialogRef.afterClosed().subscribe(async (confirmed) => {
      if (confirmed !== true) {
        return
      }
      try {
        await this.createEditorDocumentMutation.mutateAsync({ meetingId: this.meeting.id })
      } catch {
        this.toastService.show('EDITOR.LEGACY_MINUTES.REGENERATION_FAILED')
      }
    })
  }
}
